import { writable } from 'svelte/store';
import { Ids } from "./ids.js";

const toastIds = new Ids();

export const alert = writable([]);
export const addAlert = (type, title, text, icon = "info-circle") => {
    alert.update((all) => [{ id: toastIds.getFreeId(), text: text, title: title, type: type, report: false, icon: icon }, ...all]);
}

export const dismissToast = (id) => {
    alert.update((all) => all.filter((t) => t.id !== id));
};